export const defaultProjectListFilters = {
    request: 1,
    inwork: 1,
    held: 1,
    done: 1,
    canceled: 1,
    closed: 1,
};

export const defaultTrainerEventsFilters = {
    request: 1,
    work: 1,
    annul: 0,
    hold: 0,
    done: 0,
    close: 0
};

export const defaultWorksheetListFilters = {
    finalist: 1,
    outFinalist: 1,
    candidates: 1,
    outCandidates: 1,
    applicant: 1,
    outApplicant: 1,
    probation: 1,
    probationFail: 1,
    probationSuccess: 1,
};

export const defaultApprovalListFilters = {
    inwork: 1,
    approved: 0,
    rejected: 0,
    canceled: 0,
};

export const defaultProjectMassListFilters = {
    request: 1,
    inwork: 1,
    hold: 1,
    done: 1,
    canceled: 1,
    close: 1
};

export const defaultNotDoneListFilters = {};

export const defaultApplicationListFilters = {
    inwork: 1,
    closed: 0,
    rejected: 0,
};

export const defaultApprovalApplicationListFilters = {
    inwork: 1,
    close: 0,
    cancel: 0,
};

export const defaultCourseListFilters = {
    assessment: 1,
    training: 0,
};

export const defaultEventListFilters = {
    courses: 1,
    actions: 0,
};

export const defaultMetroRequestApprovalFilters = {
    inwork: 1,
    closed: 0,
    rejected: 0,
    canceled: 0,
};

export const defaultMetroRequestFilters = {
    all: 1,
    draft: 0,
    inwork: 0,
    rejected: 0,
    canceled: 0,
    closed: 0,
};
